import {
    DatePicker,
    DateTimePicker,
    LocalizationProvider,
} from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs, { Dayjs } from 'dayjs'
import { useCallback, useMemo } from 'react'

import { COLORS } from '../Colors'

require('dayjs/locale/pt-br')

type CustomDatePickerProps = {
    format?: string
    minDate?: dayjs.Dayjs
    maxDate?: dayjs.Dayjs
    defaultValue?: dayjs.Dayjs
    value?: dayjs.Dayjs
    label: string
    useTime?: boolean
    onChange: (date: Dayjs) => void
}

export default function CustomDatePicker({
    format = 'DD/MM/YYYY',
    minDate,
    maxDate,
    defaultValue,
    value,
    label,
    useTime,
    onChange,
}: CustomDatePickerProps) {
    const handleChange = useCallback(
        (dayJs: Dayjs | null) => {
            onChange(dayJs as Dayjs)
        },
        [onChange]
    )

    const sharedProps = useMemo(
        () => ({
            minDate,
            maxDate,
            slotProps: {
                day: {
                    sx: {
                        color: COLORS.brownishGrey,
                        fontWeight: 700,
                    },
                },
                layout: {
                    sx: {
                        '& .MuiDayCalendar-weekDayLabel': {
                            color: COLORS.primaryOrange,
                        },
                        backgroundColor: COLORS.borderGray,
                    },
                },
            },
            format,
            label,
            defaultValue,
            value,
        }),
        [minDate, maxDate, format, label, defaultValue, value]
    )

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {useTime ? (
                <DateTimePicker
                    {...sharedProps}
                    ampm={false}
                    views={['year', 'month', 'day', 'hours', 'minutes']}
                    minutesStep={1}
                    onChange={handleChange}
                />
            ) : (
                <DatePicker {...sharedProps} onChange={handleChange} />
            )}
        </LocalizationProvider>
    )
}
